import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=519500ca&scoped=true"
import script from "./Step2.vue?vue&type=script&lang=js"
export * from "./Step2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519500ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Wampp-latest\\www\\REZOSYSTEMS\\dev-ski-rentals5\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('519500ca')) {
      api.createRecord('519500ca', component.options)
    } else {
      api.reload('519500ca', component.options)
    }
    module.hot.accept("./Step2.vue?vue&type=template&id=519500ca&scoped=true", function () {
      api.rerender('519500ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/reservations/advance/steps/Step2.vue"
export default component.exports